import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import endpoints from '../endpoints.ts';
import api from '../api/index.ts';
import { Toast } from '../types/models';
import { USER_QUERY_KEY } from '../queryHooks/userQueryHooks.ts';
import { UserAPI } from '../api/user';

const useUpdateOtherSettings = (
  options?: Partial<
    UseMutationOptions<
      Toast | null,
      unknown,
      UserAPI.Request.UpdateOtherSettings
    >
  >
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [endpoints.user.update.otherSettings()],
    mutationFn: api.user.update.otherSettings,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [USER_QUERY_KEY],
      });
    },
    ...options,
  });
};

const userMutationHooks = {
  useUpdateOtherSettings,
};

export default userMutationHooks;
